<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit"
          @click="group1.onSubmitButtonClicked"
        >設定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">書籍の更新情報</span>
        </div>
        <div class="popup-content">
          <div class="popup-content-block">
            <p class="txt-sup">更新情報をご希望される書籍を選択してください。</p>
          </div>
          <div class="list01">
            <FontawesomeIcon v-if="!group1.isListPackagesAndProductsLoaded" 
            :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
            <template v-else>

              <template v-if="group1.packagesAndProductsAreaTreeData.packages && group1.packagesAndProductsAreaTreeData.packages.length > 0">
              <SPProfileContractedBooksTreeItem
                :model="group1.packagesAndProductsAreaTreeData"
                @emitItemClicked="group1.onPackageAndProductsTreeItemClicked"
              />
              </template>

              <template v-if="group1.packagesAndProductsAreaBooks.length > 0">
                <ul>
                  <li v-for="item in group1.packagesAndProductsAreaBooks"
                    :key="'single_books_' + item.id" class="list01-item is-parent is-open">
                    <div class="label">
                      <div class="formparts checkbox">
                        <input type="checkbox" 
                          v-model="group1.single_books"
                          :value="item.book_id"
                          @change="group1.onSingleBookClicked"
                          :id="'package_product_books_' + item.book_id">
                        <label :for="'package_product_books_' + item.book_id">{{ item.name }} <FontawesomeIcon icon="check" class="icn" /></label>
                      </div>
                    </div>
                  </li>
                </ul>
              </template>

            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import SPProfileContractedBooksTreeItem from '@/components/sp/partial/profile/SPProfileContractedBooksTreeItem'
import * as logicProfileContractedBookSetting from '@/logic/profile/ProfileContractedBookSetting'

export default defineComponent({
  components: {
    SPProfileContractedBooksTreeItem
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true
    },
    currentAlertBooks: {
      type: Array,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicProfileContractedBookSetting.getGroup(props, context)

    const close = () => {
      context.emit('closeProfileContractedBookSetting')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    &-block {
      padding: 20px;
      border-bottom: 1px solid $color-line;
    }
  }
}
</style>
